export default __webpack_public_path__ + "static/737-557aceb674dfcc51197a74e9cba6f193.gif";